import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="toggle-secret"
export default class extends Controller {
  static targets = ["secret"]

  secretTargetConnected(element) {
    element.classList.add("hidden-text")
  }

  toggle() {
    this.secretTargets.forEach(
      (element) => {
        element.classList.toggle("hidden-text")
      }
    )
  }
}
